var BannerSlider = function () {

	this.init = function () {
		$('[data-component="banner-slider"]').slick({
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 1000
		});
	}

	return this.init();
}
